import { Descriptions, Empty } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { FC } from 'react';
import { FULL_DATE_FORMAT } from 'constants/dates';

type PaymentType = {
  id: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payment_info?: any | null;
  reason?: string | null;
  source?: string | null;
  created_at: string;
};

interface PaymentDetailsProps {
  payments: PaymentType[];
}

const PaymentDetails: FC<PaymentDetailsProps> = ({ payments }) => {
  const formatDate = (dateString: string) => {
    return dayjs(dateString).format(FULL_DATE_FORMAT);
  };

  const renderSource = (payment: PaymentType) => {
    const isStripePayment =
      payment?.source === 'stripe' &&
      payment.payment_info &&
      typeof payment.payment_info === 'object' &&
      'id' in payment.payment_info &&
      payment.payment_info.id;

    if (isStripePayment) {
      return (
        <a
          href={`https://dashboard.stripe.com/payments/${payment.payment_info.id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            color: '#1890ff',
            gap: 4
          }}
        >
          Stripe
          <ArrowRightOutlined />
        </a>
      );
    }

    return payment?.source || 'N/A';
  };

  if (!payments || payments.length === 0) {
    return (
      <div style={{ padding: '16px', minWidth: '200px' }}>
        <Empty
          description="No payment information available"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: '8px 0' }}
        />
      </div>
    );
  }

  return (
    <>
      {payments.map((payment, index) => (
        <div key={payment.id} style={{ marginBottom: 16 }}>
          <h6 style={{ marginBottom: 8, color: '#1890ff', fontSize: '13px' }}>
            Record #{index + 1}
          </h6>
          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label="Payment ID">
              {payment.id}
            </Descriptions.Item>
            <Descriptions.Item label="Source">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {renderSource(payment)}
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="Created At">
              {formatDate(payment.created_at)}
            </Descriptions.Item>
            <Descriptions.Item label="Payment Details">
              {payment.payment_info ? (
                <pre
                  style={{
                    background: '#f6f8fa',
                    padding: 6,
                    borderRadius: 3,
                    fontSize: '10px',
                    maxHeight: '120px',
                    overflow: 'auto',
                    border: '1px solid #e1e4e8',
                    margin: 0
                  }}
                >
                  {JSON.stringify(payment.payment_info, null, 2)}
                </pre>
              ) : (
                <span style={{ color: '#999' }}>
                  No payment details available
                </span>
              )}
            </Descriptions.Item>
          </Descriptions>
        </div>
      ))}
    </>
  );
};

export default PaymentDetails;
